import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("ul", {
  class: "sidebar-nav nav nav-tabs pt-15 pb-5 px-5",
  id: "kt_sidebar_tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      href: "#kt_sidebar_tab_pane_1",
      id: "kt_sidebar_tab_1"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/purple/aven.svg",
        class: "default"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/colored/aven.svg",
        class: "active"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      href: "#kt_sidebar_tab_pane_2",
      id: "kt_sidebar_tab_2"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/purple/kanba.svg",
        class: "default"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/colored/kanba.svg",
        class: "active"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      "data-bs-toggle": "tab",
      href: "#kt_sidebar_tab_pane_3",
      id: "kt_sidebar_tab_3"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/purple/fox-hub-2.svg",
        class: "default"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/colored/fox-hub-2.svg",
        class: "active"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      href: "#kt_sidebar_tab_pane_4",
      id: "kt_sidebar_tab_4"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/purple/tower.svg",
        class: "default"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/colored/tower.svg",
        class: "active"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      href: "#kt_sidebar_tab_pane_5",
      id: "kt_sidebar_tab_5"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/purple/treva.svg",
        class: "default"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: "media/svg/logo/colored/treva.svg",
        class: "active"
      })
    ])
  ])
], -1)
const _hoisted_2 = {
  id: "kt_sidebar_content",
  class: "py-10 px-5 px-lg-5"
}
const _hoisted_3 = {
  class: "hover-scroll-y me-lg-n2 pe-lg-2",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0px",
  "data-kt-scroll-dependencies": "#kt_sidebar_tabs, #kt_sidebar_footer",
  "data-kt-scroll-wrappers": "#kt_sidebar_content"
}
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane",
  id: "kt_sidebar_tab_pane_1",
  role: "tabpanel"
}
const _hoisted_6 = { class: "card bg-transparent" }
const _hoisted_7 = { class: "card-header align-items-center border-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Aven Sales", -1)
const _hoisted_9 = { class: "card-toolbar" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = { class: "card-body px-3 py-0" }
const _hoisted_13 = { class: "card bg-transparent" }
const _hoisted_14 = { class: "card-header align-items-center border-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, " Tasks Overview ", -1)
const _hoisted_16 = { class: "card-toolbar" }
const _hoisted_17 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_18 = { class: "svg-icon svg-icon-1" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0\"><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-1.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Sunspots </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Mark, Rowling, Esther </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-2.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Ocean Drive </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Study the highway types </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-3.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Soar, Eco </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> HTML, CSS. jQuery </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-5.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Cup &amp; Green </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> ASP.NET Developer </span></div></div><div class=\"d-flex flex-wrap align-items-center\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-6.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Bose QC 35 II </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Study the highway types </span></div></div></div>", 1)
const _hoisted_20 = {
  class: "tab-pane",
  id: "kt_sidebar_tab_pane_2",
  role: "tabpanel"
}
const _hoisted_21 = { class: "card bg-transparent" }
const _hoisted_22 = { class: "card-header align-items-center border-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Kanba Sales", -1)
const _hoisted_24 = { class: "card-toolbar" }
const _hoisted_25 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_26 = { class: "svg-icon svg-icon-1" }
const _hoisted_27 = { class: "card-body px-3 py-0" }
const _hoisted_28 = { class: "card bg-transparent" }
const _hoisted_29 = { class: "card-header align-items-center border-0" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, " Kanba Products ", -1)
const _hoisted_31 = { class: "card-toolbar" }
const _hoisted_32 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_33 = { class: "svg-icon svg-icon-1" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0\"><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-7.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> BP Industries </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Successful Fellas </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-8.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Automatica </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Successful Fellas </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-9.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Python Inc. </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Most Successful </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-19.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Cup &amp; Green </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> ASP.NET Developer </span></div></div><div class=\"d-flex flex-wrap align-items-center\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-6.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Active Customers </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Best Customers </span></div></div></div>", 1)
const _hoisted_35 = {
  class: "tab-pane active",
  id: "kt_sidebar_tab_pane_3",
  role: "tabpanel"
}
const _hoisted_36 = { class: "card bg-transparent" }
const _hoisted_37 = { class: "card-header align-items-center border-0" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Fox Sales", -1)
const _hoisted_39 = { class: "card-toolbar" }
const _hoisted_40 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_41 = { class: "svg-icon svg-icon-1" }
const _hoisted_42 = { class: "card-body px-3 py-0" }
const _hoisted_43 = { class: "card bg-transparent" }
const _hoisted_44 = { class: "card-header align-items-center border-0" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, " Fox Bestsellers ", -1)
const _hoisted_46 = { class: "card-toolbar" }
const _hoisted_47 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_48 = { class: "svg-icon svg-icon-1" }
const _hoisted_49 = { class: "card-body pt-0" }
const _hoisted_50 = { class: "d-flex flex-wrap align-items-center mb-7" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/stock/600x400/img-17.jpg",
    alt: "",
    class: "mw-100"
  })
], -1)
const _hoisted_52 = { class: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Новая страница ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-white opacity-25 fw-bold fs-7 my-1" }, " Study the highway types ", -1)
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-17.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Blue Donut </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Study the highway types </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-10.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Lovely Hearts </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Study the highway types </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-1.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Hands &amp; Yellow </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Study the highway types </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-9.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Cup &amp; Green </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Study the highway types </span></div></div><div class=\"d-flex flex-wrap align-items-center\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-4.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Bose QC 35 II </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Study the highway types </span></div></div>", 5)
const _hoisted_60 = {
  class: "tab-pane",
  id: "kt_sidebar_tab_pane_4",
  role: "tabpanel"
}
const _hoisted_61 = { class: "card bg-transparent" }
const _hoisted_62 = { class: "card-header align-items-center border-0" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Tower Sales", -1)
const _hoisted_64 = { class: "card-toolbar" }
const _hoisted_65 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_66 = { class: "svg-icon svg-icon-1" }
const _hoisted_67 = { class: "card-body px-3 py-0" }
const _hoisted_68 = { class: "card bg-transparent" }
const _hoisted_69 = { class: "card-header align-items-center border-0" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, " Tower Latest Products ", -1)
const _hoisted_71 = { class: "card-toolbar" }
const _hoisted_72 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_73 = { class: "svg-icon svg-icon-1" }
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0\"><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-8.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Automatica </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Successful Fellas </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-11.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> BP Industries </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Successful Fellas </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-19.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Cup &amp; Green </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> ASP.NET Developer </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-9.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Python Inc. </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Most Successful </span></div></div><div class=\"d-flex flex-wrap align-items-center\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-6.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Active Customers </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Best Customers </span></div></div></div>", 1)
const _hoisted_75 = {
  class: "tab-pane",
  id: "kt_sidebar_tab_pane_5",
  role: "tabpanel"
}
const _hoisted_76 = { class: "card bg-transparent" }
const _hoisted_77 = { class: "card-header align-items-center border-0" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Treva Sales", -1)
const _hoisted_79 = { class: "card-toolbar" }
const _hoisted_80 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_81 = { class: "svg-icon svg-icon-1" }
const _hoisted_82 = { class: "card-body px-3 py-0" }
const _hoisted_83 = { class: "card bg-transparent" }
const _hoisted_84 = { class: "card-header align-items-center border-0" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, " Treva's Products ", -1)
const _hoisted_86 = { class: "card-toolbar" }
const _hoisted_87 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_88 = { class: "svg-icon svg-icon-1" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0\"><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-12.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Top Authors </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Successful Fellas </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-13.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Popular Authors </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> Most Successful </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-14.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> New Users </a><span class=\"text-white opacity-25 fw-bold fs-7 my-1\"> HTML, CSS. jQuery </span></div></div><div class=\"d-flex flex-wrap align-items-center mb-7\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-15.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Active Customers </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Awesome Users </span></div></div><div class=\"d-flex flex-wrap align-items-center\"><div class=\"symbol symbol-40px symbol-2by3 me-4\"><img src=\"media/stock/600x400/img-16.jpg\" alt=\"\" class=\"mw-100\"></div><div class=\"d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3\"><a href=\"#\" class=\"text-white fw-bolder text-hover-primary fs-6\"> Bose QC 35 II </a><span class=\"text-white opacity-25 fs-7 fw-bold my-1\"> Best Customers </span></div></div></div>", 1)
const _hoisted_90 = {
  id: "kt_sidebar_footer",
  class: "py-2 px-5 pb-md-6 text-center"
}
const _hoisted_91 = /*#__PURE__*/_createTextVNode("View Extended Layout")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_apexchart, {
                  class: "apexcharts-bar-hover-danger",
                  options: _ctx.chartOptions,
                  series: _ctx.series1,
                  height: "250",
                  type: "bar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _hoisted_19
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_apexchart, {
                  class: "apexcharts-bar-hover-danger",
                  options: _ctx.chartOptions,
                  series: _ctx.series2,
                  height: "250",
                  type: "bar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _hoisted_34
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_apexchart, {
                  class: "apexcharts-bar-hover-danger",
                  options: _ctx.chartOptions,
                  series: _ctx.series4,
                  height: "250",
                  type: "bar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("button", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_router_link, {
                      to: { name: 'pricing' },
                      class: "text-white fw-bolder text-hover-primary fs-6"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }),
                    _hoisted_54
                  ])
                ]),
                _hoisted_55
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("button", _hoisted_65, [
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_component_apexchart, {
                  class: "apexcharts-bar-hover-danger",
                  options: _ctx.chartOptions,
                  series: _ctx.series4,
                  height: "250",
                  type: "bar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("button", _hoisted_72, [
                    _createElementVNode("span", _hoisted_73, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _hoisted_74
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("button", _hoisted_80, [
                    _createElementVNode("span", _hoisted_81, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_apexchart, {
                  class: "apexcharts-bar-hover-danger",
                  options: _ctx.chartOptions,
                  series: _ctx.series5,
                  height: "250",
                  type: "bar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("button", _hoisted_87, [
                    _createElementVNode("span", _hoisted_88, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ]),
              _hoisted_89
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_90, [
      _createVNode(_component_router_link, {
        to: "/dashboards/extended",
        class: "btn btn-color-white bg-white bg-opacity-10 bg-hover-opacity-20 fw-bolder w-100"
      }, {
        default: _withCtx(() => [
          _hoisted_91
        ]),
        _: 1
      })
    ])
  ], 64))
}